/*
 * Copyright 2025 Intuition Robotics ltd
 */
// __asset_0};

import __asset_0 from "@res/icons/icn-arrows.svg";
import * as React from 'react';
import {CSSProperties} from "react";

type Props = {
	up?: boolean
	down?: boolean
	colorOn?: string
	colorOff?: string
	upColorOn?: string
	upColorOff?: string
	downColorOn?: string
	downColorOff?: string
	height?: number
	width?: number
	className?: string
	style?: CSSProperties
}

export class IconArrows
	extends React.Component<Props> {

	private readonly width = 8;
	private readonly height = 14;

	constructor(props: Props) {
		super(props);
	}

	render() {

		let width, height;
		if (this.props.width !== undefined){
			width = this.props.width;
			height = this.height / this.width * this.props.width;
		} else if (this.props.height !== undefined){
			height = this.props.height;
			width = this.width / this.height * this.props.height;
		} else {
			width = this.width;
			height = this.height;
		}

		const upColorOn = this.props.upColorOn || this.props.colorOn || "#A4A6A8";
		const upColorOff = this.props.upColorOff || this.props.colorOff || "#A4A6A8";
		const downColorOn = this.props.downColorOn || this.props.colorOn || "#A4A6A8";
		const downColorOff = this.props.downColorOff || this.props.colorOff || "#A4A6A8";

		return <span className={this.props?.className} style={{...this.props?.style, display: 'inline-block', lineHeight: '0px'}}>
			<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width} height={height} viewBox="0 0 8 14">
			<defs>
				<path id="lxr5g8sbha"
				      d="M7 7.622c0-.284-.298-.46-.53-.31l-4.903 3.134c-.223.142-.223.48 0 .622l1.707 1.092 3.196 2.043c.232.148.53-.026.53-.31v-6.27z"/>
				<path id="bc0w5dz4bb" d="M7 .522c0-.284-.298-.46-.53-.31L1.567 3.345c-.223.142-.223.48 0 .622L3.274 5.06 6.47 7.103c.232.148.53-.026.53-.31V.522z"/>
			</defs>
			<g fill="none" fillRule="evenodd">
				<g>
					<g transform="translate(-391 -168) translate(391 168)">
						<use fill={this.props.up ? upColorOn : upColorOff} transform="matrix(0 -1 -1 0 14.957 14.957)" xlinkHref="#lxr5g8sbha"/>
						<use fill={this.props.down ? downColorOn : downColorOff} transform="matrix(0 1 1 0 .543 -.543)" xlinkHref="#bc0w5dz4bb"/>
					</g>
				</g>
			</g>
		</svg>
		</span>
	}

}
